import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import LoadingIndicator from '../../loading-indicator';
import { StoreCardSlim } from '../store-card-slim';

import { StoreCardsListContainer } from './styled/store-cards-list-container';
import { IStoreCardsListProps } from './types';

export function StoreCardsList({
  searching,
  stores,
  nearbyStoreCardRefs,
  setActiveStoreId,
  noStoresElement,
  activeStoreId,
  onClickRestaurantHoursInfo,
  buttonOnly = false,
  buttonTextOverride,
  onButtonClickOverride,
  allStoresSelectable = false,
}: IStoreCardsListProps) {
  const { formatMessage } = useIntl();
  const handleStoreCardClick = useCallback(
    restaurantId => {
      if (restaurantId === activeStoreId) {
        return;
      }

      setActiveStoreId(restaurantId);
    },
    [activeStoreId, setActiveStoreId]
  );

  if (searching) {
    return <LoadingIndicator ariaLabel={formatMessage({ id: 'locationSearch' })} />;
  }

  if (stores?.length === 0) {
    return <>{noStoresElement}</>;
  }

  return (
    <StoreCardsListContainer data-testid="store-cards-list">
      {stores?.reduce((storeCards, restaurant) => {
        if (restaurant._id) {
          storeCards.push(
            <StoreCardSlim
              innerRef={nearbyStoreCardRefs?.[restaurant._id]}
              restaurant={restaurant}
              isSelected={restaurant._id === activeStoreId}
              key={restaurant._id}
              onClick={() => handleStoreCardClick(restaurant._id)}
              onClickRestaurantHoursInfo={onClickRestaurantHoursInfo}
              buttonOnly={buttonOnly}
              buttonTextOverride={buttonTextOverride}
              onButtonClickOverride={onButtonClickOverride}
              alwaysSelectable={allStoresSelectable}
            />
          );
        }

        return storeCards;
      }, [] as React.ReactElement[])}
    </StoreCardsListContainer>
  );
}
